/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectInstrumentV1} from '../api'

export const useMutationSelectInstrumentV1 = createReactQueryMutationHook('selectInstrumentV1', selectInstrumentV1)
